module.exports = __webpack_public_path__ + "img/banner-2.ff7f5e02.jpeg";